import { twMerge } from 'tailwind-merge'
import { RadioGroup } from '@headlessui/react'

const SegmentedControl = ({ options, value, onChange, className }) => {
  return (
    <RadioGroup value={value} onChange={onChange} className={twMerge('h-[40px] inline-flex w-fit items-center gap-1 bg-muted rounded-md px-1 py-1', className)}>
      <For each='option' of={options}>
        <RadioGroup.Option value={option.value} className='flex items-center justify-center p-1 px-3 h-full rounded-sm ui-checked:bg-background ui-checked:shadow-sm text-muted-foreground text-sm ui-checked:text-foreground font-medium hover:cursor-pointer'>
          {option.label}
        </RadioGroup.Option>
      </For>
    </RadioGroup>
  )
}

export default SegmentedControl
